import { LitElement, html, css, classMap } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      type: Boolean,
      reflect: true,
    },
    disabled: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.input.checked = this.checked
    this.input.disabled = this.disabled
  }

  updated(changedProperties) {
    if (changedProperties.has('disabled')) {
      this.input.disabled = this.disabled
    }
    if (changedProperties.has('checked')) {
      this.input.checked = this.checked
    }
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot @change="${this.onChange}" name="input"></slot>
      <slot name="label"></slot>
      <slot name="checkmark"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: inline-flex;
      align-items: var(--hh-align-items, flex-start);
      column-gap: 0.8rem;
      color: var(--hh-color, #646464);
      position: relative;
    }

    ::slotted(input) {
      width: var(--hh-width, 16px);
      height: var(--hh-height, 16px);
      appearance: none;
      margin: 0;
      padding: 0;
      border: 1px solid var(--hh-color, #000);
      background-color: transparent;
      border-radius: var(--hh-border-radius, 2px);
      vertical-align: middle;
      position: relative;
      cursor: pointer;
    }

    ::slotted(input:focus) {
      border: 1px solid var(--hh-color, #646464) !important;
    }

    ::slotted(label) {
      cursor: pointer;
      cursor: pointer;
      max-width: var(--hh-label-max-width, 21rem);
      font: var(--hh-font, inherit);
    }

    :host(:hover:not([disabled])) ::slotted(label) {
      color: var(--hh-label-color-hover);
    }

    ::slotted([slot='checkmark']) {
      scale: 0;
      display: flex;
      pointer-events: none;
      position: absolute;
      top: 0;
      left: var(--hh-checkmark-left, 0.4rem);
      width: var(--hh-width, 1.6rem);
      height: var(--hh-height, 1.6rem);
      max-width: var(--hh-checkmark-max-width, 1.6rem);
      align-items: center;
      justify-content: center;
    }

    :host([checked]) ::slotted([slot='checkmark']) {
      scale: 1;
    }

    :host([disabled]) ::slotted(input) {
      background-color: var(--hh-color-input-disabled);
      border: 1px solid var(--hh-color-light);
      cursor: default;
    }

    :host([disabled]) ::slotted(label) {
      cursor: default;
    }
  `
}

if (!customElements.get('hh-checkbox-wrapper')) {
  customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper);
}